import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_PERSONAL_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdatePersonalRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = UPDATE_PERSONAL_URL;

  constructor(request) {
    super();

    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
